var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#50AF95"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58685 6.26956C6.55447 6.27196 6.3872 6.28186 6.01406 6.28186C5.71728 6.28186 5.50656 6.27303 5.43264 6.26956C4.28571 6.21956 3.42962 6.0217 3.42962 5.78481C3.42962 5.54792 4.28571 5.35033 5.43264 5.29953V6.0725C5.50764 6.07785 5.7224 6.09042 6.01919 6.09042C6.37532 6.09042 6.55366 6.07571 6.58577 6.07277V5.30006C7.73027 5.35059 8.58446 5.54845 8.58446 5.78481C8.58446 6.02117 7.73054 6.21902 6.58577 6.26929L6.58685 6.26956ZM6.58685 5.22012V4.52842H8.18408V3.47363H3.83541V4.52842H5.43237V5.21985C4.13435 5.27894 3.1582 5.53375 3.1582 5.83909C3.1582 6.14443 4.13435 6.39897 5.43237 6.45832V8.67485H6.58658V6.45752C7.88163 6.39843 8.85615 6.14389 8.85615 5.83882C8.85615 5.53375 7.88244 5.27921 6.58658 5.21985L6.58685 5.22012Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.ede58656c6328834c4284ee77281d130.svg";
export { ForwardRef as ReactComponent };